<div class="energy-reads-card">
    <div class="er-header">
        <div class="view-toggle">
            <button type="button" [class.active]="viewMode === 'graph'" (click)="setViewMode('graph')">
                <i class="bi bi-bar-chart-line"></i> {{ "GRAPH" | translate }}
            </button>
            <button type="button" [class.active]="viewMode === 'table'" (click)="setViewMode('table')">
                <i class="bi bi-table"></i> {{ "TABLE" | translate }}
            </button>
        </div>
        <div class="range-controls">
        <div class="range-tabs">
            <button type="button" *ngFor="let r of ranges" [class.active]="activeRange === r"
                (click)="selectRange(r)">{{ r }}</button>
        </div>
            @if (viewMode === 'graph') {
            <button type="button" class="reset-zoom-btn" (click)="resetZoom()" [title]="'RESET_ZOOM' | translate">
                <i class="bi bi-zoom-out"></i>
            </button>
            }
        </div>
    </div>

    @if (viewMode === 'graph') {
    <div class="chart-frame">
        @if (readings.length > 0) {
        <canvas baseChart [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins" type="line"></canvas>
        } @else {
        <div class="chart-empty-state">
            <i class="bi bi-bar-chart-line"></i>
            <span>{{ "NO_READS_FOR_RANGE" | translate }}</span>
        </div>
        }
    </div>

    <div class="chart-legend">
        <label class="legend-item" *ngFor="let s of seriesConfig; let i = index">
            @if (readings.length > 0) {
            <input type="checkbox" [checked]="seriesVisible[i]" (change)="toggleSeries(i)" />
            }
            <span class="dot" [style.background-color]="s.color"></span>
            {{ s.labelKey | translate }}
        </label>
    </div>
    }

    @if (viewMode === 'table') {
    <div #tableContainer class="table-container">
        <table>
            <thead>
                <tr>
                    <td class="custom-width">{{ "TIME" | translate | uppercase }} {{ "INTERVAL" | translate }}</td>
                    <td>{{ "ENERGYREGISTERS_ABSOLUTEENERGY" | translate | uppercase }}</td>
                    <td colspan="2">{{ "ENERGYREGISTERS_ACTIVEENERGY" | translate | uppercase }}</td>
                    <td colspan="2">{{ "ENERGYREGISTERS_REACTIVEENERGY" | translate | uppercase }}</td>
                    <td colspan="2">{{ "ENERGYREGISTERS_APPARENTENERGY" | translate | uppercase }}</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of tableRows">
                    <td class="table-name-number">
                        <span>{{ row.meterTime | date: 'dd MMM yyyy, h:mm a' }}</span>
                    </td>
                    <td>
                        {{ row.absoluteActiveEnergy == null ? 'N/A' : (row.absoluteActiveEnergy | unitConverter: 'WH') }}
                    </td>
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.activeEnergyImport + ' WH'">
                                {{ row.activeEnergyImport == null ? 'N/A' : (row.activeEnergyImport | unitConverter: 'WH') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.activeEnergyExport + ' WH'">
                                {{ row.activeEnergyExport == null ? 'N/A' : (row.activeEnergyExport | unitConverter: 'WH') }}
                            </span>
                        </div>
                    </td>
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.reactiveEnergyImport + ' VARH'">
                                {{ row.reactiveEnergyImport == null ? 'N/A' : (row.reactiveEnergyImport | unitConverter: 'VARH') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.reactiveEnergyExport + ' VARH'">
                                {{ row.reactiveEnergyExport == null ? 'N/A' : (row.reactiveEnergyExport | unitConverter: 'VARH') }}
                            </span>
                        </div>
                    </td>
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.apparentEnergyImport + ' VAH'">
                                {{ row.apparentEnergyImport == null ? 'N/A' : (row.apparentEnergyImport | unitConverter: 'VAH') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.apparentEnergyExport + ' VAH'">
                                {{ row.apparentEnergyExport == null ? 'N/A' : (row.apparentEnergyExport | unitConverter: 'VAH') }}
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="tableLastPageSize" [numberOfDevices]="tableRowCount"
            [pageSize]="tablePageSize" [currentPage]="tableCurrentPage"
            (pageChange)="loadTableRows($event)"></app-pagination>
    </div>
    }
</div>
